import React, { useEffect, useState } from "react";
import "./Hero.css";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Image from "react-bootstrap/Image";
import webdev from "../../assets/webdev.png";
import metaverse from "../../assets/metaverse.png";
import ai from "../../assets/ai.png";
import Carousel from "react-bootstrap/Carousel";
import Button from "react-bootstrap/Button";
import Background from "../Background/Background";
import Modal from "../Modal/Modal";

const Hero = () => {
  const [showModal, setShowModal] = useState(false);
  const [fontSize, setFontSize] = useState("fs-4");

  useEffect(() => {
    function handleResize() {
      if (window.innerWidth <= 440) {
        setFontSize("fs-6");
      } else {
        setFontSize("fs-5");
      }
    }

    window.addEventListener("resize", handleResize);
    handleResize(); // Llama a handleResize al cargar la página para establecer el tamaño de fuente inicial

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const handleContactClick = () => {
    setShowModal(true);
  };
  return (
    <>
      <Background />
      <Carousel
        controls={true}
        indicators={false}
        touch={true}
        className="container-h"
      >
        <Carousel.Item interval={5000}>
          <Row className="d-flex align-items-center justify-content-md-center">
            <Col
              xxl={{ span: 4, offset: 1 }}
              xl={{ span: 6, offset: 1 }}
              className="d-flex flex-column justify-content-center center-col-h"
            >
              <h1 className="txt-h1 fw-bolder">Web</h1>
              <h2 className="text-dark txt-h2">Development</h2>
              <p className={`${fontSize} text-dar txt-p`}>
                Creamos tu aplicacion web a medida.
              </p>
              <p className={`${fontSize} text-dar txt-p`}>
                Vos lo soñas nosotros lo hacemos.
              </p>
              <div className="button-hmedia">
                <Button
                  variant="dark"
                  size="lg"
                  className="btn-h mt-3 center-col-h"
                  onClick={handleContactClick}
                >
                  Consultar
                </Button>
              </div>
            </Col>
            <Col
              className="col-lg-4 col-md-5 text-center"
              style={{ display: "flex", justifyContent: "center" }}
            >
              <Image src={webdev} fluid className="img-h center-col-h" />
            </Col>
          </Row>
        </Carousel.Item>
        <Carousel.Item interval={5000}>
          <Row className="align-items-center justify-content-md-center">
            <Col
              xxl={{ span: 4, offset: 1 }}
              xl={{ span: 6, offset: 1 }}
              className="d-flex flex-column justify-content-center center-col-h"
            >
              <div className="d-flex flex-column justify-content-center center-col-h">
                <h1 className="txt2-h1 fw-bolder">Web</h1>
                <h2 className="text-dark txt-h2">Design</h2>
                <p className={`${fontSize} text-dar txt-p`}>
                  Diseñamos tu pagina web.
                </p>
                <p className={`${fontSize} text-dar txt-p`}>
                  A medida para tus necesidades.
                </p>
                <div className="button-hmedia">
                  <Button
                    variant="dark"
                    size="lg"
                    className="btn-h mt-3 center-col-h"
                    onClick={handleContactClick}
                  >
                    Consultar
                  </Button>
                </div>
              </div>
            </Col>
            <Col
              flex-column
              className="col-lg-5 col-md-6 text-center center-col-h"
            >
              <Image src={metaverse} fluid className="img1-h" />
            </Col>
          </Row>
        </Carousel.Item>
        <Carousel.Item interval={5000}>
          <Row className="align-items-center justify-content-md-center">
            <Col
              xxl={{ span: 4, offset: 1 }}
              xl={{ span: 6, offset: 1 }}
              className="d-flex flex-column justify-content-center center-col-h"
            >
              <div className="d-flex flex-column justify-content-center center-col-h">
                <h1 className="txt3-h1 fw-bolder">Infraestructura</h1>
                <h2 className="text-dark txt-h2 txt-mobile-h2">
                  Servicios y Soporte
                </h2>
                <p className={`${fontSize} text-dar txt-p`}>
                  Te damos las opciones mas modernas
                </p>
                <p className={`${fontSize} text-dar txt-p`}>
                  para llevar tu negocio al siguiente nivel.
                </p>
                <div className="button-hmedia">
                  <Button
                    variant="dark"
                    size="lg"
                    className="btn-h mt-3 center-col-h"
                    onClick={handleContactClick}
                  >
                    Consultar
                  </Button>
                </div>
              </div>
            </Col>
            <Col
              flex-column
              className="col-lg-5 col-md-6 text-center center-col-h"
            >
              <Image src={ai} fluid className="img2-h" />
            </Col>
          </Row>
        </Carousel.Item>
      </Carousel>
      <Modal show={showModal} setShow={setShowModal} />
    </>
  );
};

export default Hero;
